import { render, staticRenderFns } from "./StepDiet.vue?vue&type=template&id=5c7d4396&lang=html&"
import script from "./StepDiet.vue?vue&type=script&lang=js&"
export * from "./StepDiet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports